// extracted by mini-css-extract-plugin
module.exports = {"item":"_4bAIF","name":"lXZcS","remove":"uqwnP","selectors":"w-NTC","quantity":"pwpyD","quantity-btn":"VTURA"};